import { Data } from "./types"

export function sortData(array: Data[], key: keyof Data, order: string[]) {
  return array.sort((current, next) => {
    const positionOfCurrent = order.indexOf(current[key] as string) + 1
    const positionOfNext = order.indexOf(next[key] as string) + 1

    if (positionOfCurrent === positionOfNext) {
      return current.name.localeCompare(next.name)
    }

    return positionOfCurrent - positionOfNext
  })
}
